import { render } from "./ErrorImage.vue?vue&type=template&id=1a86f538"
import script from "./ErrorImage.vue?vue&type=script&lang=js"
export * from "./ErrorImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__